import axios, { AxiosResponse } from 'axios';

const url = '/services/isnaportal/open-api/kkm-state-registry/search?size=300';
// ?clientRecaptchaResponse=${token}
export const searchKkmRegister = (request: any, token?: any): Promise<AxiosResponse> => {
    return axios.post(`${url}`, request);
};

export const downloadAllKkm = (request: any, token?: any): Promise<AxiosResponse> => {
    return axios.post(`/services/isnaportal/open-api/kkm-state-registry/export`, request, {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    });
};
